module.exports = __webpack_public_path__ + "img/839.91dd16b3.png";